import { array as yupArray, number as yupNumber, string as yupString } from 'yup';
import 'yup_extensions';
import estimatePasswordStrength from 'helpers/estimate_password_strength';

export const validationMessages = {
  companyMessage: 'Enter your company name.',
  validEmailMessage: 'Email address needs to contain "@place.com"',
  emailMessage: 'Enter your email address.',
  numEmployeesMessage: `Must be a number between 0 and 99,999.`,
  firstNameMessage: 'Enter your first name.',
  lastNameMessage: 'Enter your last name.',
  phoneMessage: 'Enter your phone number.',
  validPhoneMessage: 'Enter a valid phone number.',
  industryMessage: 'How would you describe your industry setting?',
  atLeastOneMessage: 'At least one option is required.',
  selectionMessage: 'Please make a selection.',
  invalidCharsMessage: 'Please remove invalid characters.',
  numbersOnlyMessage: 'Invalid characters. Please use numbers only.',
  nameLenghtMessage: 'Max limit characters reached.',
};

export const getMessage = message => validationMessages[message];

export const maskRegexOrEmptStr = /^\(\d{3}\) \d{3}-\d{4}$/;

// Reference: https://github.com/jquense/yup/issues/298#issuecomment-559017330
export const emptyStringToNull = (value, originalValue) =>
  originalValue.toString().trim() === '' ? null : value;

export const validateFirstAndLastName = (message, minVal = 0) => {
  return yupString()
    .validLength(message, minVal)
    .matches(/^(?!.*(?:http|https|ftp|btc|.com))[^%@$:]*$/, getMessage('invalidCharsMessage'))
    .max(50, getMessage('nameLenghtMessage'))
    .noEmojis(getMessage('invalidCharsMessage'));
};

export const validateStr = (message, minVal = 0) => {
  return yupString().validLength(message, minVal).noEmojis(getMessage('invalidCharsMessage'));
};

export const validateNumEmployees = yupNumber()
  .typeError(getMessage('numbersOnlyMessage'))
  .min(0, getMessage('numEmployeesMessage'))
  .max(9999, getMessage('numEmployeesMessage'))
  .transform(emptyStringToNull)
  .required(getMessage('numEmployeesMessage'));

export const validateEmail = yupString()
  .email(getMessage('validEmailMessage'))
  .required(getMessage('emailMessage'));

export const validatePhoneNumber = () => {
  return yupString().matches(maskRegexOrEmptStr, getMessage('validPhoneMessage'));
};

export const validateArrayMin = (minVal, message) => {
  return yupArray().min(minVal, message).required(message);
};

export const validateSelection = message => {
  return yupString().required(message);
};

export const validatePasswordStrength = (schema, minStrength = 2) =>
  schema
    .trim()
    .test(
      'passwordStrength',
      'Stronger password required. Try adding special characters or random words.',
      value => {
        return estimatePasswordStrength(value).score >= minStrength;
      }
    )
    .required('A valid password is required.')
    .min(8, `A valid password is required.`)
    .matches(/^(?=.*[a-zA-Z])(?=.*[0-9]).*$/, 'A valid password is required.');
